export default "__VITE_ASSET__Dghm2Lfa__"